import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_TRANSACTION_SECURITY_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders the flat buyer-side transaction security fee.
 * The line item is included only for the customer, so this row never
 * shows up in the provider's breakdown.
 */
const LineItemTransactionSecurityFeeMaybe = props => {
  const { lineItems, intl } = props;

  const feeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_TRANSACTION_SECURITY_FEE && !item.reversal
  );

  return feeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.transactionSecurityFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, feeLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemTransactionSecurityFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTransactionSecurityFeeMaybe;
